module.exports = __webpack_public_path__ + "img/heading_uk.1963bdc0.svg";